import { mapState, mapGetters } from 'vuex';

export default {
  name: 'PdpCarouselImageMixin',

  computed: {
    ...mapState('cms', ['cmsSettings']),
    ...mapGetters('pdp', [
      'carouselImages',
      'perfectPairImages',
      'isPurePigment'
    ]),

    mix_pdpCarouselImages() {
      const images = [...this.carouselImages];

      if (this.cmsSettings.carouselVideo && !this.isPurePigment) {
        images.splice(3, 0, this.cmsSettings.carouselVideo);
      }

      return images;
    },

    mix_perfectPairPDPCarouselImages() {
      return [...this.perfectPairImages, ...this.carouselImages];
    }
  }
};